import React, { useEffect, useState } from "react";
import { LineChart } from "@mui/x-charts";
import Typography from "@mui/material/Typography";
import { Get } from "../../Common/WebRequest";
import { Paper } from "@mui/material";
import { showDateOnly } from "../../Common/Utility";
import "./TopStats.css";
const TopStudentsAmountByPDFDate = () => {
  const [loading, setLoading] = useState(true);
  const [topStudents, setTopStudents] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await Get("Statistics/TopStudentsAmountByPDFDate");

        if (res.isSuccess) {
          const data = res.result;
          setTopStudents(data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!topStudents || topStudents.length === 0) {
    return <div></div>;
  }

  return (
    <Paper elevation={3} className="top-container">
      <Typography align="left" variant="h6" gutterBottom>
        Betr. letzter 12 Transaktionen
      </Typography>
      <div className="chart-container">
        <LineChart
          xAxis={[
            {
              scaleType: "band",
              data: topStudents.map((item) =>
                showDateOnly(item.pdfDate).substring(5)
              ),
            },
          ]}
          yAxis={[{ id: "linearAxis", scaleType: "linear" }]}
          series={[
            {
              yAxisKey: "linearAxis",
              data: topStudents.map((item) =>
                !isNaN(item.totalAmount) ? item.totalAmount : 0
              ),
              label: "Beträge",
              color: "#5ad45a",
            },
          ]}
          leftAxis="linearAxis"
          height={250}
        />
      </div>
    </Paper>
  );
};

export default TopStudentsAmountByPDFDate;
